import { render, staticRenderFns } from "./accountPage.vue?vue&type=template&id=7a2e4cee&scoped=true"
import script from "./accountPage.vue?vue&type=script&lang=js"
export * from "./accountPage.vue?vue&type=script&lang=js"
import style0 from "./accountPage.vue?vue&type=style&index=0&id=7a2e4cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e4cee",
  null
  
)

export default component.exports